import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface ArrowIconProps {
    color?: string;
    arrowColor?: string;
    className?: string;
}

function ArrowIcon({
    color = 'currentColor',
    arrowColor = 'white',
    className = null,
}: ArrowIconProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, className])}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2929 17.2929C9.90237 17.6834 9.90237 18.3166 10.2929 18.7071C10.6834 19.0976 11.3166 19.0976 11.7071 18.7071L17.7059 12.7083C17.7099 12.7043 17.714 12.7002 17.718 12.6961C17.8925 12.5161 18 12.2706 18 12C18 11.8644 17.973 11.7351 17.9241 11.6172C17.8753 11.4993 17.803 11.3888 17.7071 11.2929L11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289C9.90237 5.68342 9.90237 6.31658 10.2929 6.70711L14.5858 11L5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13L14.5858 13L10.2929 17.2929Z"
                fill={arrowColor}
            />
        </svg>
    );
}

export default ArrowIcon;
